import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { TasksQueue, AssignedTaskQueue } from '../../types/TasksQueue';
import { addWatcherToTask, getTaskQueueAssignableUsers, getTaskQueues, removeWatcherFromTask } from '../../services/tasksQueue.service';

export interface TasksQueueState {
  tasks?: TasksQueue[] | null;
  areTasksLoading: boolean;
  assignableUsers: AssignedTaskQueue[];
  areUsersLoading: boolean;
}

const initialState: TasksQueueState = {
  tasks: null,
  areTasksLoading: false,
  assignableUsers: [],
  areUsersLoading: false,
};

export const fetchTasksQueue = createAsyncThunk('tasksQueue/getTaskQueues', async () => await getTaskQueues({}));
export const fetchTasksQueueAssignableUsers = createAsyncThunk(
  'tasksQueue/getTaskQueueAssignableUsers',
  async () => await getTaskQueueAssignableUsers()
);

export const addWatcher = createAsyncThunk('tasksQueue/addWatcher', async ({ taskId, userId }: { taskId: string | null; userId: string | null }) => {
  const updatedTask = await addWatcherToTask(taskId, userId);
  return updatedTask;
});

export const removeWatcher = createAsyncThunk(
  'tasksQueue/removeWatcher',
  async ({ taskId, userId }: { taskId: string | null; userId: string | null }) => {
    const updatedTask = await removeWatcherFromTask(taskId, userId);
    return updatedTask;
  }
);

const tasksQueueSlice = createSlice({
  name: 'taskQueue',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTasksQueue.pending, (state) => {
        state.areTasksLoading = true;
      })
      .addCase(fetchTasksQueue.fulfilled, (state, action: PayloadAction<any>) => {
        if (action.payload?.data?.results) {
          state.tasks = action.payload.data.results;
        }
        state.areTasksLoading = false;
      })
      .addCase(fetchTasksQueueAssignableUsers.pending, (state) => {
        state.areUsersLoading = true;
      })
      .addCase(fetchTasksQueueAssignableUsers.fulfilled, (state, action: PayloadAction<any>) => {
        if (action.payload.data) {
          state.assignableUsers = action.payload.data;
        }
        state.areUsersLoading = false;
      })
      .addCase(addWatcher.pending, (state) => {
        state.areTasksLoading = true;
      })
      .addCase(addWatcher.fulfilled, (state, action: PayloadAction<any>) => {
        if (action.payload?.data?.results) {
          state.tasks = action.payload.data.results;
        }
        state.areTasksLoading = false;
      })
      .addCase(removeWatcher.pending, (state) => {
        state.areTasksLoading = true;
      })
      .addCase(removeWatcher.fulfilled, (state, action: PayloadAction<any>) => {
        if (action.payload?.data?.results) {
          state.tasks = action.payload.data.results;
        }
        state.areTasksLoading = false;
      });
  },
});

export default tasksQueueSlice.reducer;
